import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    getChatConversations,
    getChatMessages,
    setSelectedConversation,
} from "../../redux/chatConversation/chatConversationSlice";
import Avatar from "../../components/Avtar/Avatar";

const ChatConversationLayer = () => {
    const dispatch = useDispatch();

    const {
        conversations = [],
        messages = [],
        selectedConversationId,
    } = useSelector((state) => state.chatConversation || {});

    const user = JSON.parse(localStorage.getItem("user"));
    const adminId = user?.id;

    const chatRef = useRef();

    const getOtherUser = (chat) => {
        if (!chat) return {};
        return chat.sender?.id === adminId
            ? chat.receiver
            : chat.sender;
    };

    useEffect(() => {
        dispatch(getChatConversations({ page: 1, limit: 20 }));
    }, []);

    useEffect(() => {
        if (selectedConversationId) {
            dispatch(
                getChatMessages({
                    conversationId: selectedConversationId,
                    page: 1,
                    limit: 50,
                })
            );
        }
    }, [selectedConversationId]);

    useEffect(() => {
        chatRef.current?.scrollTo({
            top: chatRef.current.scrollHeight,
            behavior: "smooth",
        });
    }, [messages]);

    const selectedChat = conversations.find(
        (c) => c.id === selectedConversationId
    );

    const selectedUser = getOtherUser(selectedChat);

    const handleGlobalRefresh = () => {
        dispatch(getChatConversations({ page: 1, limit: 20 }));

        if (selectedConversationId) {
            dispatch(
                getChatMessages({
                    conversationId: selectedConversationId,
                    page: 1,
                    limit: 50,
                })
            );
        }
    };

    return (
        <div className="chat-wrapper">

            <div className="chat-sidebar card">

                <div className="chat-sidebar-single top-profile d-flex align-items-center gap-2">
                    <Avatar
                        name={user?.fullName}
                        image={user?.profilePicture}
                        uniqueKey={user?.id}
                        size={28}
                    />

                    <div>
                        <h6 className="mb-0">{user?.fullName || "Admin"}</h6>
                        <small className="text-success">Online</small>
                    </div>

                    <button
                        onClick={handleGlobalRefresh}
                        className="refresh-btn ms-auto"
                    >
                        <Icon icon="solar:refresh-bold-duotone" />
                    </button>
                </div>

                <div className="chat-all-list">

                    {conversations.map((chat) => {
                        const otherUser = getOtherUser(chat);

                        return (
                            <div
                                key={chat.id}
                                onClick={() =>
                                    dispatch(setSelectedConversation(chat.id))
                                }
                                className="chat-sidebar-single d-flex align-items-center gap-2"
                                style={{
                                    cursor: "pointer",
                                    background:
                                        selectedConversationId === chat.id
                                            ? "#e7f1ff"
                                            : "",
                                    borderLeft:
                                        selectedConversationId === chat.id
                                            ? "4px solid #0d6efd"
                                            : "",
                                }}
                            >

                                <Avatar
                                    name={otherUser?.fullName}
                                    image={otherUser?.profilePicture}
                                    uniqueKey={otherUser?.id}
                                    size={28}
                                />

                                <div className="flex-grow-1">
                                    <h6 className="mb-0 text-sm">
                                        {otherUser?.fullName || "User"}
                                    </h6>

                                    <small className="text-muted">
                                        Tap to view messages
                                    </small>
                                </div>

                                <div className="text-end">
                                    <small className="text-muted">
                                        {new Date(chat.updatedAt).toLocaleTimeString([], {
                                            hour: "2-digit",
                                            minute: "2-digit",
                                        })}
                                    </small>
                                </div>
                            </div>
                        );
                    })}

                </div>
            </div>

            <div className="chat-main card d-flex flex-column">

                {!selectedChat ? (
                    <div
                        className="d-flex flex-column justify-content-center align-items-center"
                        style={{ height: "100%" }}
                    >
                        <Icon icon="mdi:chat-outline" width="60" className="mb-3 text-muted" />
                        <h6 className="text-muted">Select chat to view</h6>
                        <p className="text-xs text-secondary">
                            Choose a conversation from the left panel
                        </p>
                    </div>
                ) : (
                    <>
                        <div className="d-flex align-items-center gap-2 border-bottom p-3">

                            <Avatar
                                name={selectedUser?.fullName}
                                image={selectedUser?.profilePicture}
                                uniqueKey={selectedUser?.id}
                                size={28}
                            />

                            <div>
                                <h6 className="mb-0">
                                    {selectedUser?.fullName}
                                </h6>
                                <small className="text-success">Active</small>
                            </div>

                        </div>

                        <div
                            className="chat-message-list p-3"
                            ref={chatRef}
                            style={{ overflowY: "auto", flex: 1 }}
                        >
                            {messages.length === 0 ? (
                                <div className="text-center mt-5 text-muted">
                                    No messages yet
                                </div>
                            ) : (
                                messages.map((msg) => {
                                    const isAdmin = msg.senderId === adminId;

                                    return (
                                        <div
                                            key={msg.id}
                                            className={`d-flex mb-3 ${isAdmin
                                                ? "justify-content-end"
                                                : "justify-content-start"
                                                }`}
                                        >
                                            {!isAdmin && (
                                                <Avatar
                                                    name={msg.sender?.fullName}
                                                    image={msg.sender?.profilePicture}
                                                    uniqueKey={msg.sender?.id}
                                                    size={32}
                                                />
                                            )}

                                            <div
                                                style={{
                                                    maxWidth: "65%",
                                                    marginLeft: isAdmin ? "0" : "8px",
                                                    marginRight: isAdmin ? "8px" : "0",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "11px",
                                                        fontWeight: 600,
                                                        marginBottom: "2px",
                                                    }}
                                                >
                                                    {msg.sender?.fullName}
                                                </div>

                                                <div
                                                    style={{
                                                        background: isAdmin
                                                            ? "#dcf8c6"
                                                            : "#ffffff",
                                                        padding: "8px 12px",
                                                        borderRadius: "10px",
                                                        boxShadow:
                                                            "0 1px 2px rgba(0,0,0,0.1)",
                                                        wordBreak: "break-word",
                                                        whiteSpace: "pre-wrap",
                                                    }}
                                                >
                                                    <p
                                                        style={{
                                                            margin: 0,
                                                            fontSize: "13px",
                                                        }}
                                                    >
                                                        {msg.messageText}
                                                    </p>

                                                    <div
                                                        style={{
                                                            textAlign: "right",
                                                            fontSize: "10px",
                                                            color: "#667781",
                                                            marginTop: "4px",
                                                        }}
                                                    >
                                                        {new Date(msg.createdAt).toLocaleTimeString([], {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                        })}
                                                    </div>
                                                </div>
                                            </div>

                                            {isAdmin && (
                                                <Avatar
                                                    name={msg.sender?.fullName}
                                                    image={msg.sender?.profilePicture}
                                                    uniqueKey={msg.sender?.id}
                                                    size={32}
                                                />
                                            )}
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default ChatConversationLayer;